import { ContentGroup } from 'src/types/graphql';
import { SearchFacetFragment } from './card-facet.fragment.generated';

export interface ContentGroupOption {
  id: ContentGroup;
  label: string;
  image: string;
}

const ICONS = 'https://media.sharry.land/app/images/families';

export const CONTENT_GROUPS: readonly ContentGroupOption[] = [
  { id: ContentGroup.Wonder, label: 'landing-page.filter.wonder', image: `${ICONS}/ic-wonder.webp` },
  { id: ContentGroup.Event, label: 'landing-page.filter.event', image: `${ICONS}/ic-event.webp` },
  { id: ContentGroup.Activity, label: 'landing-page.filter.experience', image: `${ICONS}/ic-experience.webp` },
  { id: ContentGroup.Product, label: 'landing-page.filter.product', image: `${ICONS}/ic-item.webp` },
  { id: ContentGroup.Host, label: 'landing-page.filter.profile', image: `${ICONS}/ic-user.webp` },
  { id: ContentGroup.Post, label: 'landing-page.filter.post', image: `${ICONS}/ic-post.webp` },
];

export const contentGroupsIn = (facets: readonly SearchFacetFragment[]): ContentGroupOption[] =>
  CONTENT_GROUPS.filter(group => facets.some(facet => facet.contentGroup === group.id));
